import React from 'react';
import SFQuestionAndAnswer from './SFQuestionAndAnswer';
import Bookmark from './Bookmark';

const SFOnePageTest = React.memo(({ mainQAArray, onCompactAnswerClick, handleBookmarkClick, questionAnswerStates, onScientificAnswerEvalMapChange }) => {

    const getAnswerData = (uniqueID) => {
        if (questionAnswerStates && questionAnswerStates.length) {
            let qasIndex = questionAnswerStates?.findIndex(data => data.unique_id === uniqueID);
            if (qasIndex > -1) {
                if (questionAnswerStates[qasIndex] && questionAnswerStates[qasIndex].student_answer_string) {
                    let jsonData = JSON.parse(questionAnswerStates[qasIndex].student_answer_string);
                    console.debug("jsonData uniqueID>>", jsonData, uniqueID)
                    return jsonData
                }
                return []
            }
            return [];
        }

        return []
    }

    return <React.Fragment>
        {mainQAArray && mainQAArray.length ? mainQAArray.map((mainQA, mainQAIndex) => {
            console.debug("mainQA>>>>", mainQA)
            return (
                <div className={`position-relative single-qa-container ${mainQAArray.length-1 === mainQAIndex ? 'single-qa-container-last' : ''}`} key={mainQA.uniqueID}>
                    <Bookmark
                        value={mainQA.bookmarked}
                        handleBookmarkClick={() => {
                            handleBookmarkClick(mainQA.uniqueID, mainQA.question);
                        }}
                    />
                    {/* {mainQA.uniqueID} */}
                    <SFQuestionAndAnswer
                        questionNo={mainQAIndex + 1}
                        compact={true}
                        uniqueID={mainQA.uniqueID}
                        questionText={mainQA.questionText}
                        currentQuestionType={mainQA.questionType}
                        answerType={mainQA.answerType}
                        count={mainQA.uniqueID}
                        isCurrentQuestionNonGraded={mainQA.isCurrentQuestionNonGraded}
                        handleHideNavAndCat={() => { }}
                        hideNavAndCat={false}
                        hideQuestion={false}
                        handleHideQuestion={() => { }}
                        showSubmitLoader={false}
                        addActivityLog={() => { }}
                        forceUpdateHandler={false} // since there's no "Try Again" button, we make it false always
                        isMobile={false}
                        reasoningElements={mainQA.reasoningElements}
                        connectingWords={mainQA.connectingWords}
                        conclusionSentences={mainQA.conclusionSentences}
                        showReasoningElementCategoryInfo={mainQA.showReasoningElementCategoryInfo}
                        answerDisplayStyle={mainQA.answerDisplayStyle}
                        onAnswerClick={(val, index) => {
                            console.debug("val, index>>", val, index)
                            //this.onAnswerClick
                            onCompactAnswerClick(mainQA.question, mainQA.uniqueID, val);
                        }}
                        displayAnswerArr={mainQA.answerDataArr}
                        showRPAnswer={false}
                        showAnswerResponse={false}
                        answerCorrect={false}
                        displayCorrectAnswer={false}
                        currentVariableMap={mainQA.currentVariableMap}
                        questionID={mainQA.questionID}
                        showVectorAnswer={false}
                        answer_formula={mainQA.answerFormula}
                        showMQTAnswers={false}
                        onAnswerEntered={(val) => {
                            let question = mainQA.question;
                            console.debug("val>>>1111", val, question)

                            if (
                                (
                                    (question.question_type === 1 && question.answer_type === 3 && (question.answerDisplayStyle === 2 || 
                                        question.answerDisplayStyle === 3
                                    ))
                                    ||
                                    (question.question_type === 3 && question.answer_type === 3 && (question.answerDisplayStyle === 2))
                                  )
                            ) { 
                                onScientificAnswerEvalMapChange(mainQA.question, mainQA.uniqueID, val)
                            } else {
                                onCompactAnswerClick(mainQA.question, mainQA.uniqueID, val);
                            }
                            
                        }}
                        mqt_options={mainQA.mqtOptions}
                        currentVectorVariable={mainQA.tempVectorsVarMap}
                        currentVectorSettings={mainQA.vectorSettingsData}
                        vectorAnswerFormulas={mainQA.vectorAnswerFormulas}
                        selectedAnswers={
                            // answersMap && answersMap[mainQA.uniqueID] ? answersMap[mainQA.uniqueID] : []
                            // []
                            getAnswerData(mainQA.uniqueID)
                        }
                        correctAnswerVectors={null}
                        onSubmit={() => { }}

                        onAnswerChoiceDetails={(val) => {
                            let question = mainQA.question;
                            console.debug("val>>>1111 222", val, question)
                            onCompactAnswerClick(mainQA.question, mainQA.uniqueID, val);
                        }}
                        freeFormVectorOptions={mainQA.question.freeform_vector_options}
                        vectorBelowQuestionText={mainQA.question.vector_below_question_text}
                    />
                </div>
            )
        }) : null}
    </React.Fragment>
});

export default SFOnePageTest;